import intl from "react-intl-universal";

import httpService from "../_utils/http-service";
import { getAuthHttpConfig } from "../_utils/auth-utils";
import * as types from "./types";
import { traceEvent } from "../_utils/analytics-utils";

export const getPromo = (promoCode, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        "/promocodes/verify",
        {
          promoCode
        },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ promotion: res.data.data });
        } else {
          traceEvent("error", "getPromo");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "getPromo");
        callback({ success: false, message: intl.get("general.serverError") });
      });
  };
};

export const toggleCheckoutOrderModal = () => {
  return { type: types.TOGGLE_CHECKOUT_ORDER_MODAL };
};

export const collapseCheckoutOrderModal = () => {
  return { type: types.COLLAPSE_CHECKOUT_ORDER_MODAL };
};

export const applyPromoCode = (
  { customerId, orderId, promoCode },
  callback
) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    traceEvent("promo", "apply");
    httpService
      .put(
        `/customers/${customerId}/orders/${orderId}/promo/apply`,
        {
          promoCode
        },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, order: res.data.data });
        } else {
          callback({ success: false });
          traceEvent("error", "applyPromoCode");
        }
      })
      .catch(err => {
        traceEvent("error", "applyPromoCode");
        callback({ success: false, message: intl.get("general.serverError") });
      });
  };
};
